// @ts-nocheck
import {ConfEnv} from "../../../config/config";
import publicRequest from "../../../Infra/http/private.request";
import {formatQueryParams} from "../../../util/queryParams";

export const getTopGamesService = async (params?: Record<string, unknown>) => {
  const queryString = formatQueryParams(params ? [params] : []);
  return publicRequest.get(`${ConfEnv.API_GAMES.TOP_GAMES}${queryString}`);
};
